// קונפיגורציה API - SHA-SHA
const API_CONFIG = {
  // גישה לשרת דרך Vite proxy בפיתוח ו-proxy בפרודקשן (פותר בעיית HTTPS/HTTP)
  BASE_URL: import.meta.env.DEV ? '/api' : '/api-proxy.php',
  
  // Fallback URLs
  FALLBACK_URLS: [
    import.meta.env.DEV ? '/api' : '/api-proxy.php',
    '/health',
    'https://api.sha-sha.co.il'
  ],
  
  // Timeout settings
  TIMEOUT: 10000,
  
  // Retry settings
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
  
  // Headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  
  // Error messages
  ERROR_MESSAGES: {
    NETWORK_ERROR: 'שגיאת רשת - בדוק את החיבור לאינטרנט',
    SERVER_ERROR: 'שגיאת שרת - נסה שוב מאוחר יותר',
    UNAUTHORIZED: 'אין הרשאה - אנא התחבר מחדש',
    FORBIDDEN: 'גישה נדחתה - אין לך הרשאה לפעולה זו',
    NOT_FOUND: 'המשאב לא נמצא',
    VALIDATION_ERROR: 'שגיאת אימות - בדוק את הנתונים שהוזנו',
    TIMEOUT_ERROR: 'פג תוקף הבקשה - נסה שוב',
    UNKNOWN_ERROR: 'שגיאה לא ידועה - נסה שוב'
  }
};

// פונקציה לקבלת כתובת שרת  
export const getServerUrl = () => {
  return import.meta.env.DEV ? '' : '';
};

// פונקציה לקבלת כתובת API
export const getApiUrl = (endpoint) => {
  return import.meta.env.DEV ? `/api${endpoint}` : `/api${endpoint}`;
};

// פונקציה לבדיקת זמינות API
export const checkApiHealth = async () => {
  // בדיקת בריאות של שרת (דרך proxy בפיתוח ובפרודקשן)
  const healthUrl = import.meta.env.DEV ? '/health' : '/api-proxy.php/health';
  try {
    const response = await fetch(healthUrl, {
      method: 'GET',
      timeout: API_CONFIG.TIMEOUT
    });
    if (response.ok) {
      return import.meta.env.DEV ? '' : '/api-proxy.php';
    }
  } catch (error) {
    console.warn('Health check failed:', error);
  }
  
  // נסה את ה-fallback URLs
  for (const url of API_CONFIG.FALLBACK_URLS) {
    if (url.startsWith('/')) continue; // דלג על relative URLs
    
    try {
      const response = await fetch(`${url}/health`, {
        method: 'GET',
        timeout: API_CONFIG.TIMEOUT
      });
      if (response.ok) {
        return url;
      }
    } catch (error) {
      console.warn(`API ${url} לא זמין:`, error);
    }
  }
  throw new Error('כל שרתי ה-API לא זמינים');
};

export default API_CONFIG;
